<div class="flex">
  <sbnb-subnav header="Settings">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main class="flex-1 subnav__exists" [ngClass.lt-md]="{ mobile: true }">
    <!-- Header -->
    <header class="mb-8">
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs>
          <div class="flex items-center gap-3 w-auto sbnbDesktop:w-full">
            <h2 class="flex-1 nomargin">Domain Management</h2>
            <sbnb-button
              class="absolute right-0 sbnbDesktop:relative"
              size="mini"
              [label]="'+ Add Domain'"
              (clicked)="addNewDomain()"></sbnb-button>
          </div>
        </sbnb-page-header>
        <div class="flex items-center justify-between gap-2 w-full">
          <h2 class="flex-1 mb-0">Domain Management</h2>
          <sbnb-button size="mini" [label]="'+ Add Domain'" (clicked)="addNewDomain()"></sbnb-button>
        </div>
      </app-feature-flag-tabs>

      <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'direct-domains'"></sbnb-helptext-wrapper>
      <sbnb-helptext-wrapper [area]="'content'" [pageId]="'direct-domains'"></sbnb-helptext-wrapper>
    </header>

    <!-- No domains -->
    @if (!loading && domains.length === 0) {
      <sbnb-no-items
        text="Enhance your direct booking experience"
        subtext="Add your first domain to connect to your direct booking site and provide a professional, branded experience for your guests."
        [buttons]="[{ id: 'new', label: 'Add your first domain', size: 'normal' }]"
        (button)="addNewDomain()"></sbnb-no-items>
    }

    <!-- Domains -->
    @if (!loading && domains.length > 0) {
      <div class="flex gap-5 rules__rule-header">
        <div class="w-[130px] sbnbDesktop:w-[100px]">Status</div>
        <div class="flex-1">Domain Name</div>
        <div class="flex-1">Site</div>
        <div class="w-[160px] sbnbDesktop:w-[120px]">Managed By</div>
      </div>

      <a
        *ngFor="let domain of domains"
        class="flex items-center gap-5 rules__rule-container"
        [routerLink]="['/settings/domains', domain.uuid]"
        data-attribute="domain-row">
        <div class="w-[130px]">
          <sbnb-badge
            [context]="
              domain.status === 'active' && !(domain.dnsManaged && !domain.nameserverVerifiedAt)
                ? 'positive'
                : domain.status === 'pending' || (domain.dnsManaged && !domain.nameserverVerifiedAt)
                  ? 'warning'
                  : 'negative'
            ">
            {{ domain.dnsManaged && !domain.nameserverVerifiedAt ? 'Setup Required' : (domain.status | titlecase) }}
          </sbnb-badge>
        </div>

        <div class="flex-1">
          <span class="rule__title">{{ domain.name }}</span>
        </div>

        <div class="flex-1 text-sm truncate">
          {{ domain.siteName }}
        </div>

        <div class="w-[160px] text-sm">
          {{ domain.managedBy }}
        </div>
      </a>
    }

    <!-- Loading -->
    @if (loading) {
      <div class="text-center">
        <mat-spinner [diameter]="32"></mat-spinner>
      </div>
    }
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Settings">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
